import { AmazonS3Buckets } from 'lane-shared/config';

export const bucketUrl = `https://${AmazonS3Buckets.Lane}.s3.amazonaws.com/static/integrations/Essensys`;
